/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FileWorkflowStepActionWorkflow } from './fileWorkflowStepActionWorkflow';


export interface FileWorkflowStepActionResult { 
    /**
     * El paso actualizado (FileWorkflowStep)
     */
    step: object;
    /**
     * Siguiente paso activado (solo al completar)
     */
    nextStep?: object;
    workflow: FileWorkflowStepActionWorkflow;
    /**
     * Pasos posteriores cancelados (solo al rechazar)
     */
    cancelledSteps?: number;
    cancelledWorkflowIds?: Array<string>;
}

